import { useEffect, useState } from 'react';

export interface PerfStats {
  fps: number;
  /** Average frame time in milliseconds. */
  ms: number;
}

/**
 * Sample frame rate via requestAnimationFrame. Only runs while `enabled`, so the
 * FPS overlay costs nothing when it's off.
 */
export function usePerfMonitor(enabled: boolean): PerfStats {
  const [stats, setStats] = useState<PerfStats>({ fps: 0, ms: 0 });

  useEffect(() => {
    if (!enabled) return;
    let raf = 0;
    let frames = 0;
    let acc = 0;
    let last = performance.now();

    const loop = (t: number) => {
      const dt = t - last;
      last = t;
      frames += 1;
      acc += dt;
      if (acc >= 500) {
        setStats({
          fps: Math.round((frames * 1000) / acc),
          ms: Math.round((acc / frames) * 10) / 10,
        });
        frames = 0;
        acc = 0;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [enabled]);

  return stats;
}
